import { render, staticRenderFns } from "./NolabelLayout.vue?vue&type=template&id=360237c6&"
import script from "./NolabelLayout.vue?vue&type=script&lang=js&"
export * from "./NolabelLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports